import coreId from "./core/id";
import accountId from "./features/account/id";
import cardId from "./features/card/id";
import categoryId from "./features/category/id";
import cazhboxId from "./features/cazhbox/id";
import componentsId from "./features/components/id";
import customerId from "./features/customer/id";
import dashboardId from "./features/dashboard/id";
import employeeId from "./features/employee/id";
import inventoryId from "./features/inventory/id";
import posId from "./features/pos/id";
import productId from "./features/product/id";
import profileId from "./features/profile/id";
import promoId from "./features/promo/id";
import reportOfflineId from "./features/report-offline/id";
import reportOnlineId from "./features/report-online/id";
import storeId from "./features/store/id";
import supplierId from "./features/supplier/id";
import systemPointId from "./features/system-point/id";

const id = {
	...coreId,
	...accountId,
	...profileId,
	...storeId,
	...componentsId,
	...dashboardId,
	...employeeId,
	...categoryId,
	...productId,
	...inventoryId,
	...customerId,
	...cardId,
	...promoId,
	...systemPointId,
	...supplierId,
	...cazhboxId,
	...reportOfflineId,
	...reportOnlineId,
	...posId,
};

export default id;
